module.exports = __webpack_public_path__ + "img/W.cb6a9182.svg";